const megaFunc = () => {
  const header = document.querySelector('.l-header');
  const triggers = document.querySelectorAll('.js-mega-trigger');
  const panels = document.querySelectorAll('.js-mega-panel');
  const backdrop = document.querySelector('.js-mega-backdrop');

  if (!header || !triggers.length || !panels.length) return;

  let closeTimer;

  const closeMega = () => {
    panels.forEach((p) => p.classList.remove('is-open'));
    triggers.forEach((t) => t.classList.remove('is-mega-active'));
    header.classList.remove('is-mega-open');
  };

  const openMega = (target) => {
    clearTimeout(closeTimer);
    panels.forEach((p) => p.classList.toggle('is-open', p.dataset.megaPanel === target));
    triggers.forEach((t) => t.classList.toggle('is-mega-active', t.dataset.mega === target));
    header.classList.add('is-mega-open');
  };

  const scheduleClose = () => {
    clearTimeout(closeTimer);
    closeTimer = setTimeout(closeMega, 150);
  };

  triggers.forEach((trigger) => {
    trigger.addEventListener('mouseenter', () => openMega(trigger.dataset.mega));
    trigger.addEventListener('mouseleave', scheduleClose);
    trigger.addEventListener('focus', () => openMega(trigger.dataset.mega));
  });

  panels.forEach((panel) => {
    panel.addEventListener('mouseenter', () => clearTimeout(closeTimer));
    panel.addEventListener('mouseleave', scheduleClose);
  });

  if (backdrop) {
    backdrop.addEventListener('mouseenter', closeMega);
  }
};

const headerFunc = () => {
  megaFunc();

  const menuBtn = document.querySelector('.js-header-menu');
  const drawer = document.querySelector('.js-header-drawer');

  if (!menuBtn || !drawer) return;

  const levels = drawer.querySelectorAll('.l-drawer__level');
  const scroll = drawer.querySelector('.l-drawer__scroll');

  const showLevel = (predicate) => {
    levels.forEach((level) => {
      level.classList.toggle('is-active', predicate(level));
    });
    if (scroll) scroll.scrollTop = 0;
  };

  const showRoot = () => {
    showLevel((level) => level.dataset.level === '1');
  };

  const openMenu = () => {
    menuBtn.classList.add('is-open');
    drawer.classList.add('is-open');
    document.body.classList.add('is-menu-open');
  };

  const closeMenu = () => {
    menuBtn.classList.remove('is-open');
    drawer.classList.remove('is-open');
    document.body.classList.remove('is-menu-open');
    showRoot();
  };

  menuBtn.addEventListener('click', () => {
    if (drawer.classList.contains('is-open')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  drawer.addEventListener('click', (e) => {
    const closeBtn = e.target.closest('.js-drawer-close');
    if (closeBtn) {
      closeMenu();
      return;
    }

    const drill = e.target.closest('.js-drawer-drill');
    if (drill) {
      const target = drill.dataset.target;
      showLevel((level) => level.dataset.panel === target);
      return;
    }

    const back = e.target.closest('.js-drawer-back');
    if (back) {
      showRoot();
      return;
    }

    const accHead = e.target.closest('.js-drawer-acc');
    if (accHead) {
      const acc = accHead.closest('.l-drawer__acc');
      if (acc) acc.classList.toggle('is-open');
    }
  });
};

export default headerFunc;
